import { useEffect, useRef } from "react";
import { runThanosSnap } from "../utils/thanosSnap";

type Props = {
  active: boolean;
  onSettled: () => void;
  children: React.ReactNode;
  className?: string;
};

export default function ThanosSnap({
  active,
  onSettled,
  children,
  className,
}: Props) {
  const wrapRef = useRef<HTMLDivElement | null>(null);
  const startedRef = useRef(false);
  const settledRef = useRef(onSettled);
  settledRef.current = onSettled;

  useEffect(() => {
    if (!active || startedRef.current) return;
    startedRef.current = true;
    const el = wrapRef.current;
    if (!el) {
      settledRef.current();
      return;
    }
    let cancelled = false;
    void runThanosSnap(el).finally(() => {
      if (!cancelled) settledRef.current();
    });
    return () => {
      cancelled = true;
    };
  }, [active]);

  return (
    <div
      ref={wrapRef}
      className={`inline-block w-fit max-w-full align-top ${className || ""}`}
      style={active ? { pointerEvents: "none" } : undefined}
    >
      {children}
    </div>
  );
}
